module.exports = __webpack_public_path__ + "static/itsm_capabilities_3_4-5c54971acef1b815e1f62db3d02481b2.png";